import { Daily10EntryScreen } from '@/screens/daily10/Daily10EntryScreen'

export default function Daily10Route() {
  return <Daily10EntryScreen />
}
